export enum FORM_NAME {
  CREATE_OFFER = 'CREATE_OFFER',
  UPDATE_OFFER = 'UPDATE_OFFER',
}
